import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { VcenterWebComponentSchema } from '../types';

export class VcenterBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<VcenterWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
